const config = {
  domain: process.env.REACT_APP_DOMAIN,
  nodeDomain: process.env.REACT_APP_NODE_DOMAIN,
  cookieDomain: process.env.REACT_APP_COOKIE_DOMAIN,
};

export const getNodeAssetUrl = (path, fallback = "") => {
  if (!path) {
    return fallback;
  }

  if (/^(https?:|data:|blob:)/i.test(path)) {
    return path;
  }

  const nodeDomain = config.nodeDomain;

  if (!nodeDomain) {
    return path.startsWith("/") ? path : `/${path}`;
  }

  const baseUrl = `${nodeDomain.replace(/\/$/, "")}/`.replace(/\/api\/?$/i, "/");

  try {
    return new URL(path, baseUrl).toString();
  } catch {
    return fallback;
  }
};

export default config;
